(() => {
  'use strict';
  const T = window.ttT || {};
  const woorden = (s) => (s || '').toLowerCase().split(',').map((x) => x.trim()).filter(Boolean);
  const losvast = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const keuze = (s) => woorden(s).map(losvast).join('|') || 'xxgeenxx';
  const $ = (sel, root = document) => root.querySelector(sel);
  const money = (cents) => new Intl.NumberFormat('nl-NL', {
    style: 'currency', currency: window.ttShop?.currency || 'EUR'
  }).format(cents / 100);
  class TtDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      document.addEventListener('click', this.onDocClick = (e) => {
        const opener = e.target.closest(`[data-drawer="${this.id}"]`);
        if (opener) { e.preventDefault(); this.open(); }
      });
      this.dialog.addEventListener('click', (e) => {
        if (e.target.closest('[data-close]') || e.target === this.dialog) this.close();
      });
      // Escape sluit langs dezelfde weg als het kruisje, met de animatie.
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
      // iOS Safari schuift de dialog zelf opzij om de knop met focus in beeld te
      // halen terwijl het paneel nog buiten beeld staat. Dan schoof de lade eerst
      // de verkeerde kant op en sprong hij daarna op zijn plek. De dialog mag
      // nooit zelf scrollen; alleen het paneel erin.
      this.dialog.addEventListener('scroll', () => {
        if (this.dialog.scrollLeft || this.dialog.scrollTop) { this.dialog.scrollLeft = 0; this.dialog.scrollTop = 0; }
      });
    }
    disconnectedCallback() { document.removeEventListener('click', this.onDocClick); }
    // Openen en sluiten schuiven via de css: is-open zet de lade op zijn plek.
    // Wie tijdens het sluiten weer opent, krijgt de lade meteen terug: de
    // beweging keert om vanaf waar hij is, in plaats van eerst af te maken.
    // Met een transition in plaats van een keyframe-animatie: die start in
    // iOS Safari niet betrouwbaar in een net geopende dialog, en een transition
    // kan halverwege gewoon omkeren.
    open() {
      clearTimeout(this.dichtTimer);
      this.dialog.classList.remove('is-dicht');
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.dialog.scrollLeft = 0; this.dialog.scrollTop = 0;
        void this.dialog.offsetWidth;
        requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
      } else {
        this.dialog.classList.add('is-open');
      }
      document.documentElement.style.overflow = 'hidden';
    }
    close() {
      if (!this.dialog.open || this.dialog.classList.contains('is-dicht')) return;
      this.dialog.classList.add('is-dicht');
      this.dialog.classList.remove('is-open');
      this.dichtTimer = setTimeout(() => {
        this.dialog.classList.remove('is-dicht');
        this.dialog.close();
        if (!document.querySelector('dialog.drawer[open]')) document.documentElement.style.overflow = '';
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 160 : 260);
    }
  }
  customElements.define('tt-drawer', TtDrawer);
  const cart = {
    async get() { return (await fetch('/cart.js')).json(); },
    async add(id, qty = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: qty }] })
      });
      if (!res.ok) throw new Error((await res.json()).description || T.fout);
      return res.json();
    },
    async change(key, qty) {
      return (await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })).json();
    }
  };
  function renderProgress(total) {
    document.querySelectorAll('[data-progress]').forEach((el) => {
      const ship = Number(el.dataset.ship || 0);
      const fill = $('.progress__fill', el);
      const goal = $('.progress__goal', el);
      if (fill) fill.style.width = Math.min(100, (total / ship) * 100) + '%';
      if (!goal) return;
      if (total < ship) {
        goal.innerHTML = T.doel1.replace('{verzending}', money(ship - total));
      } else {
        goal.textContent = T.doel0;
      }
    });
  }
  async function refresh() {
    const data = await cart.get();
    document.querySelectorAll('[data-cart-count]').forEach(n => {
      n.textContent = data.item_count;
      n.hidden = data.item_count === 0;
    });
    renderProgress(data.total_price);
    const body = $('[data-cart-body]');
    if (body) {
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      // De cadeauvelden staan in het deel dat hier wordt vervangen. Wat de klant
      // net typte is misschien nog niet bewaard, dus dat zetten we terug.
      const cdVink = body.querySelector('[data-cadeau]');
      const cdWas = cdVink ? {
        aan: cdVink.checked,
        voor: body.querySelector('[data-cadeau-voor]')?.value,
        tekst: body.querySelector('[data-cadeau-tekst]')?.value,
      } : null;
      ['[data-cart-body]', '[data-cart-foot]'].forEach((sel) => {
        const oud = $(sel), nieuw = html.querySelector(sel);
        if (oud && nieuw) oud.innerHTML = nieuw.innerHTML;
      });
      if (cdWas) {
        const v = body.querySelector('[data-cadeau]');
        if (v) v.checked = cdWas.aan;
        const velden = body.querySelector('[data-cadeau-velden]');
        if (velden) velden.hidden = !cdWas.aan;
        const voor = body.querySelector('[data-cadeau-voor]');
        if (voor && cdWas.voor != null) voor.value = cdWas.voor;
        const tekst = body.querySelector('[data-cadeau-tekst]');
        if (tekst && cdWas.tekst != null) tekst.value = cdWas.tekst;
      }
      renderProgress(data.total_price);
    }
    return data;
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const id = form.querySelector('[name=id]')?.value;
    if (!id) return;
    // innerHTML, niet textContent: de knop op de productkaart heeft een icoon en
    // een tekst in een span, en die moeten na het toevoegen allebei terug.
    const label = btn?.innerHTML;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Bezig…'; }
    try {
      await cart.add(Number(id), Number(form.querySelector('[name=quantity]')?.value || 1));
      await refresh();
      document.getElementById('cart-drawer')?.open();
    } catch (err) {
      const slot = form.querySelector('[data-error]');
      if (slot) slot.textContent = err.message;
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
    }
  });
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-qty]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      const next = Math.max(0, Number(input.value) + Number(step.dataset.qty));
      input.value = next;
      await cart.change(step.closest('[data-key]').dataset.key, next);
      if (input.name.startsWith('updates')) { window.location.reload(); return; }
      await refresh();
      return;
    }
    const remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      await cart.change(remove.closest('[data-key]').dataset.key, 0);
      await refresh();
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('input[name^="updates"]');
    if (!input) return;
    const line = input.closest('[data-key]');
    if (!line) return;
    await cart.change(line.dataset.key, Math.max(0, Number(input.value) || 0));
    window.location.reload();
  });
  document.querySelectorAll('[data-hide-with-js]').forEach(b => b.setAttribute('hidden', ''));
  // Mailadres terugzetten (zie snippets/mail-link.liquid): omgekeerd en in base64.
  const zetMail = (root = document) => root.querySelectorAll('a[data-m]').forEach((a) => {
    try {
      const adres = atob(a.dataset.m).split('').reverse().join('');
      a.href = 'mailto:' + adres;
      const t = a.querySelector('[data-m-tekst]');
      if (t) t.textContent = adres;
      a.removeAttribute('data-m');
    } catch (e) {  }
  });
  zetMail();
  document.addEventListener('shopify:section:load', (e) => zetMail(e.target));
  // Easy Tickets telt op de eventslijst de plekken van alle tickettypes bij elkaar op.
  // Delen de types een gezamenlijk aantal plekken (Midnight Release: 4 types, 5 plekken),
  // dan staat er 4 x 5 = 20. Het echte getal staat als availableTotal in de eventgegevens
  // van de app; dat zetten we erin zodra de app de kaarten heeft getekend.
  const etLijst = document.querySelector('.shopify-app-block[id$="__events"]');
  if (etLijst) {
    const etGedaan = new WeakSet();
    const etPlekken = () => etLijst.querySelectorAll('a.et-card[href*="/products/"]').forEach(async (kaart) => {
      const plek = kaart.querySelector('.et-card__spots');
      if (!plek || etGedaan.has(plek) || !/\d/.test(plek.textContent)) return;
      etGedaan.add(plek);
      try {
        const handle = new URL(kaart.href).pathname.split('/products/')[1].split('/')[0];
        const p = await (await fetch(`/products/${handle}.js`)).json();
        const c = await (await fetch(`/apps/easy-tickets/api/event-config/${p.id}`)).json();
        const n = c && c.availableTotal;
        if (typeof n !== 'number') return;
        if (n > 0) plek.textContent = plek.textContent.replace(/\d+/, String(n));
        else plek.hidden = true;
      } catch (e) {  }
    });
    etPlekken();
    new MutationObserver(etPlekken).observe(etLijst, { childList: true, subtree: true });
  }
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('select[data-submit-on-change]');
    if (sel) sel.form?.submit();
  });
  const headerWrap = document.querySelector('.section-header')
    || document.querySelector('.header')?.parentElement;
  if (headerWrap) {
    const drempel = 100;
    const marge = 8;
    let vorige = window.scrollY;
    let omhoog = 0;
    let verborgen = false;
    const zet = (waarde) => {
      if (waarde === verborgen) return;
      verborgen = waarde;
      headerWrap.classList.toggle('is-hidden', waarde);
    };
    window.addEventListener('scroll', () => {
      const y = window.scrollY > 0 ? window.scrollY : 0;
      const d = y - vorige;
      vorige = y;
      if (y <= drempel) { omhoog = 0; zet(false); return; }
      if (d > 0) {
        omhoog = 0;
        if (!document.querySelector('dialog.drawer[open]')) zet(true);
      } else if (d < 0) {
        omhoog -= d;
        if (omhoog >= marge) zet(false);
      }
    }, { passive: true });
  }
  const navGroups = () => document.querySelectorAll('[data-nav-group][open]');
  document.addEventListener('click', (e) => {
    const inside = e.target.closest('[data-nav-group]');
    navGroups().forEach(g => { if (g !== inside) g.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') navGroups().forEach(g => g.removeAttribute('open'));
  });
  const raster = document.querySelector('[data-cards]');
  const meer = document.querySelector('[data-meer]');
  if (raster && meer && 'IntersectionObserver' in window) {
    let bezig = false;
    const kijker = new IntersectionObserver(async (regels) => {
      if (!regels[0].isIntersecting || bezig || !meer.dataset.meer) return;
      bezig = true;
      try {
        const res = await fetch(meer.dataset.meer);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('[data-cards] > *').forEach((el) => raster.appendChild(el));
        const volgende = doc.querySelector('[data-meer]');
        meer.dataset.meer = volgende ? volgende.dataset.meer : '';
      } catch (e) {
        meer.dataset.meer = '';
      }
      bezig = false;
      if (!meer.dataset.meer) { kijker.disconnect(); meer.remove(); }
    }, { rootMargin: '700px' });
    kijker.observe(meer);
  }
  const filterPanel = document.getElementById('filters');
  if (filterPanel) {
    filterPanel.querySelector('[data-apply]')?.setAttribute('hidden', '');
    filterPanel.addEventListener('change', (e) => {
      if (e.target.matches('[data-autosubmit]')) e.target.form?.submit();
    });
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-filters-toggle]');
    if (!t || !filterPanel) return;
    const open = filterPanel.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(open));
  });
  // Cadeau: het vakje, voor wie, en een eigen berichtje (snippets/cadeau-regel).
  // Ze staan soms twee keer op de pagina (lade en winkelwagenpagina), dus we
  // houden ze gelijk. Bewaren gaat als winkelwagenkenmerk: bij het vakje meteen,
  // bij typen even na de laatste toets. Vakje uit betekent alles leeg naar de
  // bestelling, maar de getypte tekst blijft in het veld staan voor als je hem
  // weer aanzet.
  const cadeauStand = () => {
    const aan = document.querySelector('[data-cadeau]')?.checked === true;
    return {
      aan,
      voor: aan ? (document.querySelector('[data-cadeau-voor]')?.value.trim() || '') : '',
      bericht: aan ? (document.querySelector('[data-cadeau-tekst]')?.value.trim() || '') : '',
    };
  };
  let cadeauTimer;
  const cadeauBewaar = () => {
    clearTimeout(cadeauTimer);
    const s = cadeauStand();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Cadeau: s.aan ? 'Ja' : '', 'Cadeau voor': s.voor, Cadeaubericht: s.bericht } }),
    }).catch(() => {});
  };
  const cadeauGelijk = (veld) => {
    if (veld.matches('[data-cadeau]')) {
      document.querySelectorAll('[data-cadeau]').forEach((v) => { v.checked = veld.checked; });
      document.querySelectorAll('[data-cadeau-velden]').forEach((b) => { b.hidden = !veld.checked; });
      return;
    }
    const sel = veld.matches('[data-cadeau-voor]') ? '[data-cadeau-voor]' : '[data-cadeau-tekst]';
    document.querySelectorAll(sel).forEach((v) => { if (v !== veld) v.value = veld.value; });
  };
  document.addEventListener('input', (e) => {
    const veld = e.target.closest('[data-cadeau-voor],[data-cadeau-tekst]');
    if (!veld) return;
    cadeauGelijk(veld);
    clearTimeout(cadeauTimer);
    cadeauTimer = setTimeout(cadeauBewaar, 700);
  });
  document.addEventListener('change', (e) => {
    const veld = e.target.closest('[data-cadeau],[data-cadeau-voor],[data-cadeau-tekst]');
    if (!veld) return;
    cadeauGelijk(veld);
    cadeauBewaar();
  });
  // Bij afrekenen gaan de cadeaugegevens nog een keer mee in het formulier zelf,
  // voor wie meteen na het typen op Afrekenen tikt. Ze komen achteraan, zodat
  // ze winnen van wat er eventueel al in het formulier stond.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || form.matches('[data-add]')) return;
    if (!form.querySelector('[name=checkout]') || !document.querySelector('[data-cadeau]')) return;
    clearTimeout(cadeauTimer);
    form.querySelectorAll('[data-cadeau-mee]').forEach((i) => i.remove());
    const s = cadeauStand();
    [['Cadeau', s.aan ? 'Ja' : ''], ['Cadeau voor', s.voor], ['Cadeaubericht', s.bericht]].forEach(([k, w]) => {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = `attributes[${k}]`;
      i.value = w;
      i.setAttribute('data-cadeau-mee', '');
      form.appendChild(i);
    });
  });
  function bouwPdpTekst() {
    const sleutel = (t) => {
      t = (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (woorden(T.kopSmaak).some((w) => t.indexOf(w) === 0)) return 'smaak';
      if (woorden(T.kopIng).some((w) => t.indexOf(w) === 0)) return 'ing';
      if (woorden(T.kopZet).some((w) => t.indexOf(w) === 0)) return 'zet';
      return null;
    };
    const pdp = document.querySelector('[data-pdp-tabs]');
    if (pdp) {
      const src = pdp.querySelector('[data-src]');
      const ben = src?.querySelector('.tat-benefits-container');
      const benMount = document.querySelector('[data-benefits]');
      if (ben && benMount) {
        ben.style.margin = '0';
        benMount.appendChild(ben);
      }
      const bakken = { magic: [], smaak: [], ing: [], zet: [] };
      let huidig = 'magic';
      Array.from(src?.childNodes || []).forEach((node) => {
        if (node.nodeType === 3) { if (node.textContent.trim()) bakken[huidig].push(node); return; }
        if (node.nodeType !== 1) return;
        const k = sleutel(node.textContent);
        if (k) {
          huidig = k;
          if (node.textContent.replace(/\s+/g, ' ').trim().length <= 14) return;
          const b = node.querySelector('b,strong');
          if (b && sleutel(b.textContent)) b.remove();
          bakken[huidig].push(node);
          return;
        }
        bakken[huidig].push(node);
      });
      if (src && (bakken.smaak.length || bakken.ing.length || bakken.zet.length || ben)) {
        ['magic', 'smaak', 'ing'].forEach((k) => {
          const p = pdp.querySelector(`[data-panel="${k}"]`);
          if (p) bakken[k].forEach((n) => p.appendChild(n));
        });
        src.hidden = true;
        const nav = pdp.querySelector('[data-tabnav]');
        if (nav) nav.hidden = false;
        const eerste = pdp.querySelector('[data-panel="magic"]');
        if (eerste) eerste.classList.add('is-active');
        ['smaak', 'ing'].forEach((k) => {
          const p = pdp.querySelector(`[data-panel="${k}"]`);
          if (p && !p.textContent.trim()) pdp.querySelector(`[data-tab="${k}"]`)?.setAttribute('hidden', '');
        });
        pdp.querySelectorAll('[data-tab]').forEach((btn) => {
          btn.addEventListener('click', () => {
            pdp.querySelectorAll('[data-tab]').forEach((b) => {
              b.classList.remove('is-active');
              b.setAttribute('aria-selected', 'false');
            });
            pdp.querySelectorAll('[data-panel]').forEach((p) => p.classList.remove('is-active'));
            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');
            pdp.querySelector(`[data-panel="${btn.dataset.tab}"]`)?.classList.add('is-active');
          });
        });
      }
    }
  }
  function bouwGalerij() {
    const track = document.querySelector('[data-gal-track]');
    if (track && !track.dataset.klaar) {
      track.dataset.klaar = '1';
      const slides = [...track.querySelectorAll('.gal__slide')];
      const thumbs = [...document.querySelectorAll('.pdp__media .thumbs a')];
      const prev = document.querySelector('.gal__nav--prev');
      const next = document.querySelector('.gal__nav--next');
      let huidig = 0;
      const ganaar = (i) => {
        huidig = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[huidig].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      const zetPijlen = () => {
        if (prev) prev.disabled = huidig === 0;
        if (next) next.disabled = huidig === slides.length - 1;
      };
      document.querySelectorAll('[data-gal]').forEach((btn) => {
        btn.addEventListener('click', () => ganaar(huidig + Number(btn.dataset.gal)));
      });
      thumbs.forEach((a, i) => a.addEventListener('click', (e) => { e.preventDefault(); ganaar(i); }));
      const strook = document.querySelector('.pdp__media .thumbs');
      const rij = strook && strook.closest('[data-thumbrow]');
      const meet = () => rij.classList.toggle('is-scroll', strook.scrollWidth > strook.clientWidth + 2);
      const inBeeld = () => {
        const a = thumbs[huidig];
        if (!rij || !a) return;
        const links = a.offsetLeft - 8;
        const rechts = links + a.offsetWidth + 16 - strook.clientWidth;
        strook.scrollLeft = Math.min(links, Math.max(rechts, strook.scrollLeft));
      };
      if (rij) {
        rij.querySelectorAll('[data-thumb]').forEach((btn) => btn.addEventListener('click', () => {
          strook.scrollLeft += btn.dataset.thumb * strook.clientWidth * 0.8;
        }));
        window.addEventListener('resize', meet, { passive: true });
        meet();
      }
      if ('IntersectionObserver' in window) {
        const kijker = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            huidig = slides.indexOf(en.target);
            thumbs.forEach((a, i) => a.classList.toggle('is-active', i === huidig));
            zetPijlen();
            inBeeld();
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach((el) => kijker.observe(el));
      }
      zetPijlen();
    }
  }
  function bouwKoopbalk() {
    const mainBuy = document.querySelector('form[data-add][data-main]');
    const buybar = document.querySelector('[data-buybar]');
    if (mainBuy && buybar && !buybar.dataset.klaar && 'IntersectionObserver' in window) {
      buybar.dataset.klaar = '1';
      new IntersectionObserver(([entry]) => {
        const voorbij = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        buybar.classList.toggle('is-visible', voorbij);
      }).observe(mainBuy);
    }
  }
  const bouwProductpagina = () => { bouwPdpTekst(); bouwGalerij(); bouwKoopbalk(); };
  bouwProductpagina();
  document.addEventListener('shopify:section:load', bouwProductpagina);
  const faqZoek = $('[data-faqzoek]');
  if (faqZoek) faqZoek.addEventListener('input', () => {
    const q = faqZoek.value.trim().toLowerCase();
    let raak = 0;
    document.querySelectorAll('[data-faqitem]').forEach((el) => {
      const hit = !q || el.textContent.toLowerCase().includes(q);
      el.hidden = !hit;
      if (hit) { raak++; if (q) el.open = true; }
    });
    document.querySelectorAll('[data-faqgroep]').forEach((g) => {
      g.hidden = !g.querySelector('[data-faqitem]:not([hidden])');
    });
    const leeg = $('[data-faqleeg]');
    if (leeg) leeg.hidden = raak > 0;
  });
  const bouwSlider = (hs) => {
    if (hs.dataset.klaar) return;
    hs.dataset.klaar = '1';
    const slides = [...hs.querySelectorAll('[data-hs-slide]')];
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let nu = 0, tikker = null, lus = null, leeft = false;
    hs.querySelectorAll('[data-vonken]').forEach((laag) => {
      for (let i = 0; i < Number(laag.dataset.vonken || 0); i++) {
        const v = document.createElement('span');
        v.classList.add('hs__vonk');
        v.style.left = `${(Math.random() * 100).toFixed(1)}%`;
        v.style.setProperty('--v', `${(3 + Math.random() * 6).toFixed(1)}px`);
        v.style.setProperty('--vd', `${(5 + Math.random() * 6).toFixed(1)}s`);
        v.style.setProperty('--vw', `${(Math.random() * 7).toFixed(1)}s`);
        laag.appendChild(v);
      }
    });
    // De plaats van de zwevende beelden en het product staat in de CSS (--x/--xm),
    // per schermbreedte. Vroeger zette dit script ze na het laden, en dan
    // versprongen ze op desktop (layout shift).
    // De beelden van slide twee en verder staan in data-src, zodat ze de eerste
    // tekening niet ophouden. Wek ze zodra de browser tijd over heeft, en in elk
    // geval voordat hun slide in beeld komt.
    const wek = (slide) => {
      if (!slide || slide.dataset.gewekt) return;
      slide.dataset.gewekt = '1';
      slide.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    };
    const rustmoment = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
    addEventListener('load', () => rustmoment(() => slides.forEach(wek)), { once: true });
    const teller = hs.querySelector('[data-hs-nu]');
    const toon = (n) => {
      nu = (n + slides.length) % slides.length;
      wek(slides[nu]);
      wek(slides[(nu + 1) % slides.length]);
      slides.forEach((s, i) => s.classList.toggle('is-on', i === nu));
      if (teller) teller.textContent = nu + 1;
    };
    hs.querySelectorAll('[data-hs-ga]').forEach((btn) => {
      btn.addEventListener('click', () => { toon(nu + Number(btn.dataset.hsGa)); herstart(); });
    });
    // Vegen. De slide volgt de vinger 1:1 en de volgende komt er al
    // doorheen; bij loslaten beslist de vaart (doorgerekend zoals Apple een
    // veeg uitrolt), niet alleen de afstand. Pas na 10 px weten we of het een
    // veeg opzij is; omhoog en omlaag blijft gewoon scrollen (touch-action:
    // pan-y in de css). Bij minder beweging: alleen de oude veeg bij loslaten.
    let vanX = 0, vanY = 0, as = null, kand = null, dxNu = 0, sporen = [], opruim = null;
    const schoon = (el) => { if (el) { el.style.transition = ''; el.style.transform = ''; el.style.opacity = ''; el.style.visibility = ''; } };
    const kandidaat = (dx) => slides[(nu + (dx < 0 ? 1 : -1) + slides.length) % slides.length];
    hs.addEventListener('touchstart', (e) => {
      clearTimeout(opruim); slides.forEach(schoon);
      vanX = e.touches[0].clientX; vanY = e.touches[0].clientY;
      as = null; kand = null; dxNu = 0; sporen = [{ x: vanX, t: e.timeStamp }];
    }, { passive: true });
    hs.addEventListener('touchmove', (e) => {
      if (rustig || slides.length < 2) return;
      const x = e.touches[0].clientX, dx = x - vanX, dy = e.touches[0].clientY - vanY;
      if (!as) { if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return; as = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; if (as === 'x') stop(); }
      if (as !== 'x') return;
      dxNu = dx;
      sporen.push({ x, t: e.timeStamp }); if (sporen.length > 6) sporen.shift();
      const w = hs.clientWidth || 1, p = Math.min(1, Math.abs(dx) / w), cur = slides[nu], k = kandidaat(dx);
      if (kand && kand !== k) schoon(kand);
      kand = k;
      cur.style.transition = 'none'; cur.style.transform = `translateX(${dx}px)`; cur.style.opacity = String(1 - p * 0.5);
      k.style.transition = 'none'; k.style.visibility = 'visible'; k.style.opacity = String(p);
    }, { passive: true });
    hs.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - vanX;
      const dy = e.changedTouches[0].clientY - vanY;
      if (rustig || slides.length < 2) {
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { toon(nu + (dx < 0 ? 1 : -1)); herstart(); }
        return;
      }
      if (as !== 'x') return;
      const a = sporen[0], b = sporen[sporen.length - 1];
      const vaart = b.t > a.t ? (b.x - a.x) / (b.t - a.t) : 0; // px per ms
      const uitrol = dxNu + vaart * 499; // Apple: v/1000 * 0.998 / (1 - 0.998), v in px/s
      const w = hs.clientWidth || 1, cur = slides[nu];
      const curve = 'cubic-bezier(.32,.72,0,1)';
      if (Math.abs(uitrol) > w / 3 && Math.sign(uitrol) === Math.sign(dxNu || uitrol)) {
        const richting = uitrol < 0 ? 1 : -1;
        cur.style.transition = `transform .35s ${curve}, opacity .35s ${curve}`;
        cur.style.transform = `translateX(${-richting * w * 0.4}px)`; cur.style.opacity = '0';
        if (kand) { kand.style.transition = ''; kand.style.opacity = ''; kand.style.visibility = ''; }
        toon(nu + richting);
      } else {
        cur.style.transition = `transform .3s ${curve}, opacity .3s ${curve}`;
        cur.style.transform = 'translateX(0)'; cur.style.opacity = '1';
        if (kand) { kand.style.transition = ''; kand.style.opacity = ''; kand.style.visibility = ''; }
      }
      const weg = cur;
      opruim = setTimeout(() => schoon(weg), 400);
      as = null; kand = null;
      herstart();
    }, { passive: true });
    const wacht = Number(hs.dataset.auto || 0) * 1000;
    // Automatisch doorschuiven stopt bij minder beweging, zolang iemand er met
    // de muis of het toetsenbord in zit, en als de pauzeknop aan staat.
    let hand = false, gepauzeerd = false;
    const start = () => { if (wacht && slides.length > 1 && leeft && !rustig && !hand && !gepauzeerd && !tikker) tikker = setInterval(() => toon(nu + 1), wacht); };
    const stop = () => { clearInterval(tikker); tikker = null; };
    const herstart = () => { stop(); start(); };
    hs.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hand = true; stop(); } });
    hs.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hand = false; start(); } });
    hs.addEventListener('focusin', () => { hand = true; stop(); });
    hs.addEventListener('focusout', (e) => { if (!hs.contains(e.relatedTarget)) { hand = false; start(); } });
    // Pauzeknop tussen de twee pijltjes, alleen als de slider vanzelf
    // doorschuift. Tussen, niet erachter: de css draait de pijl van het eerste
    // en het laatste knopje in .hs__nav.
    const pijl = hs.querySelector('[data-hs-ga]');
    if (pijl && wacht && slides.length > 1 && !rustig) {
      const taal = (document.documentElement.lang || 'nl').slice(0, 2);
      const w = { nl: ['Pauzeer de slider', 'Speel de slider af'], en: ['Pause slideshow', 'Play slideshow'], de: ['Slider pausieren', 'Slider abspielen'], fr: ['Mettre en pause', 'Lire le diaporama'] }[taal] || ['Pauzeer de slider', 'Speel de slider af'];
      const knop = pijl.cloneNode(false);
      delete knop.dataset.hsGa;
      knop.type = 'button';
      knop.classList.add('hs__pauze');
      const teken = () => {
        knop.setAttribute('aria-label', gepauzeerd ? w[1] : w[0]);
        knop.setAttribute('aria-pressed', String(gepauzeerd));
        knop.innerHTML = gepauzeerd
          ? '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>';
      };
      teken();
      knop.addEventListener('click', () => { gepauzeerd = !gepauzeerd; teken(); gepauzeerd ? stop() : start(); });
      pijl.after(knop);
    }
    const dingen = [];
    let mx = 0, my = 0, dx = 0, dy = 0;
    if (hs.dataset.zweef && !rustig) {
      hs.querySelectorAll('[data-diep]').forEach((el) => dingen.push({
        el,
        midden: el.classList.contains('hs__zweef') || el.classList.contains('hs__pak'),
        diep: Number(el.dataset.diep) || 1.5,
        t: Math.random() * 6.28,
        snel: 0.5 + Math.random() * 0.5,
        wijd: 5 + Math.random() * 7
      }));
      hs.addEventListener('mousemove', (e) => {
        const r = hs.getBoundingClientRect();
        dx = (e.clientX - r.left) / r.width - 0.5;
        dy = (e.clientY - r.top) / r.height - 0.5;
      });
      hs.addEventListener('mouseleave', () => { dx = 0; dy = 0; });
    }
    const beeld = () => {
      mx += (dx - mx) * 0.06; my += (dy - my) * 0.06;
      dingen.forEach((o) => {
        o.t += 0.02 * o.snel;
        const zy = Math.sin(o.t) * o.wijd;
        const zx = Math.cos(o.t * 0.7) * o.wijd * 0.5;
        const basis = o.midden ? 'translate(-50%,-50%) ' : '';
        o.el.style.transform = `${basis}translate(${(-mx * o.diep * 22 + zx).toFixed(1)}px,${(-my * o.diep * 22 + zy).toFixed(1)}px)`;
      });
      lus = requestAnimationFrame(beeld);
    };
    const zet = (aan) => {
      if (aan === leeft) return;
      leeft = aan;
      hs.classList.toggle('is-stil', !aan);
      if (aan) { if (dingen.length && lus === null) lus = requestAnimationFrame(beeld); start(); }
      else { if (lus !== null) { cancelAnimationFrame(lus); lus = null; } stop(); }
    };
    new IntersectionObserver(([e]) => zet(e.isIntersecting && !document.hidden), { threshold: 0.01 }).observe(hs);
    document.addEventListener('visibilitychange', () => { if (document.hidden) zet(false); });
  };
  const bouwSliders = () => document.querySelectorAll('[data-hs]').forEach(bouwSlider);
  bouwSliders();
  document.addEventListener('shopify:section:load', bouwSliders);
  const bouwBanner = (bb) => {
    if (bb.dataset.klaar) return;
    bb.dataset.klaar = '1';
    const spoor = bb.querySelector('[data-bb-spoor]');
    if (!spoor || !spoor.children.length) return;
    const echt = Array.from(spoor.children);
    const kopie = () => echt.map((plak) => {
      const k = plak.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      return k;
    });
    kopie().forEach((k) => spoor.insertBefore(k, echt[0]));
    kopie().forEach((k) => spoor.appendChild(k));
    // De breedte van één rijtje, gemeten aan het verschil tussen de eerste plak
    // van de kopie ervoor en de eerste plak van het echte rijtje. Meten via
    // scrollWidth zou de ruimte links en rechts van het spoor meetellen.
    const rij = () => spoor.children[echt.length].offsetLeft - spoor.children[0].offsetLeft;
    // Waar het spoor moet staan om deze plak in het midden te zetten.
    const plek = (plak) => plak.offsetLeft + plak.offsetWidth / 2 - spoor.clientWidth / 2;
    // Alle plakken zijn even breed, dus welke er nu in het midden staat volgt uit
    // de stand van het spoor. Scheelt het aflopen van de hele rij.
    const dichtstbij = () => Math.round((spoor.scrollLeft - plek(spoor.children[0])) / (rij() / echt.length));
    // Rechtstreeks zetten, met het happen even uit, anders trekt scroll-snap de
    // band meteen naar het dichtstbijzijnde boek terug.
    const zet = (x) => {
      spoor.style.scrollSnapType = 'none';
      spoor.scrollLeft = x;
      spoor.style.scrollSnapType = '';
    };
    // Welke plak in het midden hoort te staan. We tellen die zelf bij, en kijken
    // niet naar waar de band op dit moment is: klikt iemand twee keer snel achter
    // elkaar, dan telt de tweede klik er gewoon bij op in plaats van dat hij in
    // de nog lopende beweging verdwijnt.
    let doel = echt.length;
    let schuivend = false;
    const terugzetten = () => {
      if (schuivend) return;
      doel = dichtstbij();
      const r = rij();
      const basis = plek(spoor.children[echt.length]);
      const x = spoor.scrollLeft;
      if (x < basis - r * 0.5) { zet(x + r); doel += echt.length; }
      else if (x > basis + r * 0.5) { zet(x - r); doel -= echt.length; }
    };
    zet(plek(spoor.children[doel]));
    let tekening = null;
    const schuif = (doel) => {
      cancelAnimationFrame(tekening);
      const begin = spoor.scrollLeft;
      const afstand = doel - begin;
      if (!afstand) return;
      schuivend = true;
      spoor.style.scrollSnapType = 'none';
      const t0 = performance.now();
      const stapje = (nu) => {
        const deel = Math.min((nu - t0) / 420, 1);
        spoor.scrollLeft = begin + afstand * (1 - Math.pow(1 - deel, 3));
        if (deel < 1) {
          tekening = requestAnimationFrame(stapje);
        } else {
          spoor.style.scrollSnapType = '';
          schuivend = false;
          terugzetten();
        }
      };
      tekening = requestAnimationFrame(stapje);
    };
    const rustig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ga = (richting) => {
      const plak = spoor.children[doel + richting];
      if (!plak) return;
      doel += richting;
      if (rustig) { zet(plek(plak)); terugzetten(); return; }
      schuif(plek(plak));
    };
    let stil = null;
    spoor.addEventListener('scroll', () => {
      clearTimeout(stil);
      stil = setTimeout(terugzetten, 150);
    }, { passive: true });
    const wacht = Number(bb.dataset.bb || 0) * 1000;
    let tikker = null, inbeeld = false, hand = false;
    const start = () => { if (wacht && !rustig && inbeeld && !hand && !tikker) tikker = setInterval(() => ga(1), wacht); };
    const stop = () => { clearInterval(tikker); tikker = null; };
    const pauze = (aan) => { hand = aan; if (aan) stop(); else start(); };
    bb.querySelectorAll('[data-bb-ga]').forEach((knop) => {
      knop.addEventListener('click', () => { ga(Number(knop.dataset.bbGa)); stop(); start(); });
    });
    bb.addEventListener('pointerenter', () => pauze(true));
    bb.addEventListener('pointerleave', () => pauze(false));
    bb.addEventListener('focusin', () => pauze(true));
    bb.addEventListener('focusout', () => pauze(false));
    spoor.addEventListener('touchstart', () => pauze(true), { passive: true });
    new IntersectionObserver(([e]) => {
      inbeeld = e.isIntersecting && !document.hidden;
      inbeeld ? start() : stop();
    }, { threshold: 0.2 }).observe(bb);
  };
  const bouwBanners = () => document.querySelectorAll('[data-bb]').forEach(bouwBanner);
  bouwBanners();
  document.addEventListener('shopify:section:load', bouwBanners);
})();

/* Audit 02-11-2026: drie kleine dingen die alleen op een telefoon iets doen.
   1. De kolommen in de footer klappen dicht op een smal scherm (data-footer-groep).
   2. De intro boven een collectie toont twee regels met Lees meer (data-inkort).
   3. In de band Vertrouwen staan vandaag en morgen open; de hele week zit achter
      een knop (data-uren-alle).
   Zonder JavaScript staat alles gewoon helemaal open. */
(() => {
  'use strict';
  const smal = window.matchMedia('(max-width: 749px)');

  const footer = () => {
    document.querySelectorAll('[data-footer-groep]').forEach((d) => { d.open = !smal.matches; });
  };
  footer();
  smal.addEventListener?.('change', footer);
  // Op een breed scherm is het kopje geen knop: daar blijft de kolom open.
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-footer-groep] > summary');
    if (s && !smal.matches) e.preventDefault();
  });

  const zetKnop = (knop, open) => {
    knop.setAttribute('aria-expanded', String(open));
    const tekst = open ? knop.dataset.tekstOpen : knop.dataset.tekstDicht;
    const svg = knop.querySelector('svg');
    knop.textContent = tekst || '';
    if (svg) knop.appendChild(svg);
  };

  const intro = () => {
    document.querySelectorAll('[data-inkort]').forEach((tekst) => {
      const knop = tekst.parentElement.querySelector('[data-inkort-knop]');
      if (!knop) return;
      tekst.classList.add('is-kort');
      // Alleen een knop als er echt iets verborgen is.
      knop.hidden = !(smal.matches && tekst.scrollHeight > tekst.clientHeight + 4);
      if (knop.hidden) tekst.classList.remove('is-kort');
    });
  };
  intro();
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-inkort-knop]');
    if (!knop) return;
    const tekst = document.getElementById(knop.getAttribute('aria-controls'));
    if (!tekst) return;
    const open = tekst.classList.toggle('is-open');
    zetKnop(knop, open);
  });

  document.querySelectorAll('[data-uren]').forEach((blok) => {
    blok.classList.add('is-kort');
    const knop = blok.querySelector('[data-uren-alle]');
    if (knop) knop.hidden = false;
  });
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-uren-alle]');
    if (!knop) return;
    const blok = knop.closest('[data-uren]');
    const open = blok.classList.toggle('is-open');
    zetKnop(knop, open);
  });

  // De hoogte van de kop, voor de balk met Sorteren en Filters die op een
  // telefoon net onder de kop blijft staan zolang de kop in beeld is.
  const kop = document.querySelector('.section-header');
  const meetKop = () => { if (kop) document.documentElement.style.setProperty('--kop-h', kop.offsetHeight + 'px'); };
  meetKop();
  window.addEventListener('resize', meetKop, { passive: true });

  // Filters openen vanuit de balk bovenin: dan het paneel in beeld brengen,
  // anders klapt het open op een plek waar je net niet kijkt.
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.colbar [data-filters-toggle]')) return;
    requestAnimationFrame(() => {
      const paneel = document.getElementById('filters');
      if (paneel && paneel.classList.contains('is-open')) paneel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  });

  document.addEventListener('shopify:section:load', () => { footer(); intro(); meetKop(); });
})();
